var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4282,
    x2: 15.4282,
    y1: 15.1847,
    y2: 33.9942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fc7e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4975ad"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 18.8571,
    x2: 7.72206,
    y1: 17.1429,
    y2: 6.06264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fc7e2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#295792"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fc7e2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4975ad"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 15.7992,
    x2: 5.52646,
    xlinkHref: "#c",
    y1: 27.9589,
    y2: 18.0186
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 26.8738,
    x2: 21.1704,
    xlinkHref: "#c",
    y1: 24.0428,
    y2: 18.3413
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 4.28556,
    x2: 26.5708,
    y1: 28.2856,
    y2: 28.2856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#816965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654e48"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4283,
    x2: 15.4283,
    y1: 9.96771,
    y2: 21.6629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d54003"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 32.1428,
    x2: 19.4493,
    y1: 18.4284,
    y2: 7.2938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d54003",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a40002"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.5714 12.2152v16.0706h-22.28576v-16.0706l11.14286-10.50084z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5714 12.8927v17.1074h-7.0363l-15.24946-15.206v-1.9014l11.14286-11.17834z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.1429 30.0002h-10.7816l-5.92669-6.1252c-.26091-.1748-.43461-.4782-.43461-.8223v-4.9298c0-.5401.42546-.9798.94807-.9798h3.43883c.3337 0 .6273.1795.7964.4491l-.0258.0212z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.96703 24h-2.79113c-.17605 0-.31872-.1899-.31872-.4241v-5.1518c0-.2342.14267-.4241.31872-.4241h2.79113c.17607 0 .31867.1899.31867.4241v5.1518c0 .2342-.1426.4241-.31867.4241z",
    fill: "#503837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.2287 24.0002h-3.31453c-.50406 0-.91417-.4376-.91417-.9756v-4.906c0-.5379.41005-.9755.91417-.9755h3.31453c.504 0 .9142.4376.9142.9755v4.906c0 .538-.4102.9756-.9142.9756zm-3.15733-1.1434h3.00003v-4.5703h-3.00003z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.5715 18.9054v9.3805h-.3029l-5.3072-5.3085c-.2344-.1515-.3899-.4144-.3899-.7126v-4.2725c0-.4681.381-.8492.8497-.8492h3.0788c.2988 0 .5616.1555.7131.3892l.0122.0096-.0082.0088z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.28564 26.5713h22.28576v2.4286c0 .5522-.4478 1-1 1h-20.28576c-.55228 0-1-.4478-1-1z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5383 24h-2.7911c-.1761 0-.3187-.1899-.3187-.4241v-5.1518c0-.2342.1426-.4241.3187-.4241h2.7911c.1761 0 .3187.1899.3187.4241v5.1518c0 .2342-.1427.4241-.3187.4241z",
    fill: "#503837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8002 24.0002h-3.3145c-.5041 0-.9142-.4376-.9142-.9756v-4.906c0-.5379.4101-.9755.9142-.9755h3.3145c.5041 0 .9142.4376.9142.9755v4.906c0 .538-.4101.9756-.9142.9756zm-3.1573-1.1434h3v-4.5703h-3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.963 14.614-12.8686-13.46924c-.3668-.383768-.9615-.383768-1.3283 0l-12.87179 13.46814c-.23994.251-.23994.6581 0 .9092l.54857.574c.23993.2511.62899.2511.86899 0l11.94353-12.49679c.0965-.10103.2531-.10103.3497 0l11.9403 12.49789c.2399.2511.629.2511.869 0l.5485-.574c.24-.2511.24-.6581.0001-.9092z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0927 1.14479c-.1835-.191947-.4238-.287856-.6642-.287856v2.666616c.0632 0 .1265.0253.1748.07578l11.9417 12.49787c.24.2511.6291.2511.8691 0l.5487-.574c.2399-.251.2399-.6581 0-.9092z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8572 30.0002v-10.5861c0-1.2543 1.1513-2.271 2.5714-2.271 1.4202 0 2.5714 1.0168 2.5714 2.271v10.5861z",
    fill: "#ffbf5c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.8571 29.9999h-1.1908v-10.8317c0-.9532-.808-1.7331-1.7956-1.7331h-.0271c-.9917 0-1.7956.7759-1.7956 1.7331v10.8317h-1.1908v-10.8186c0-1.5992 1.3431-2.8957 3-2.8957 1.6568 0 3 1.2965 3 2.8957z",
    fill: "#ffe7a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.0001 22.2856c.2367 0 .4286-.3838.4286-.8572s-.1919-.8571-.4286-.8571-.4286.3837-.4286.8571.1919.8572.4286.8572z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3D);
export default __webpack_public_path__ + "static/media/home_3d.0b288caba5beb53a83ae726fe78602dc.svg";
export { ForwardRef as ReactComponent };